/*
 * wow-enquiry.js — prefills the Kontakt form.
 * - ?stykke=<handle> (furniture, from a piece's closing button): only a handle of
 *   a published portfolio piece (data-wow-pieces JSON) prefills Emne with the
 *   generic furniture subject (no piece name; 2026-10-03) and the hidden
 *   contact[mobel] / contact[mobel_handle].
 * - ?emne=besok (from an "Avtal et besøk" link, 2026-10-01): Emne = the visit
 *   subject. With &stykke=<lamp handle> (a published lamp, data-wow-lamps JSON)
 *   the subject names the lamp and the hidden contact[lampe] / contact[lampe_handle]
 *   / contact[henvendelse]=besok are sent. An unknown lamp handle falls back to
 *   the plain visit subject.
 * - An unknown emne is ignored (stykke then works as above); anything else
 *   leaves a plain empty form.
 * No visible strings here: subject templates come from data attributes rendered
 * from locale keys. "besok" is a stable URL/field key, not visible text.
 *
 * Also turns the obfuscated e-mail on Kontakt into a mailto link: the address
 * is rendered as separate data-user / data-domain attributes (never whole in
 * the HTML); without JS the visible fallback is "user [at] domain" (the "[at]"
 * word comes from a locale key). "mailto:" and "@" are protocol syntax, not text.
 */
(() => {
  document.querySelectorAll('[data-wow-email]').forEach((el) => {
    const user = el.getAttribute('data-user');
    const domain = el.getAttribute('data-domain');
    if (!user || !domain) return;
    const a = document.createElement('a');
    a.className = el.getAttribute('data-link-class') || '';
    a.href = 'mailto:' + user + '@' + domain;
    a.textContent = user + '@' + domain;
    el.replaceWith(a);
  });

  const root = document.querySelector('[data-wow-enquiry]');
  if (!root) return;

  const params = new URLSearchParams(window.location.search);
  const emne = params.get('emne');
  const handle = params.get('stykke');
  const VISIT = 'besok';

  const readJson = (selector) => {
    try {
      return JSON.parse((root.querySelector(selector) || {}).textContent || '{}');
    } catch (e) {
      return {};
    }
  };
  const has = (obj, key) => key && Object.prototype.hasOwnProperty.call(obj, key);

  const templates = root.querySelector('[data-wow-subject-template]');
  const subject = root.querySelector('[data-wow-subject]');
  const setSubject = (attr, name) => {
    if (!subject || !templates || subject.value) return;
    const text = templates.getAttribute(attr);
    if (text) subject.value = name ? text.replace('__NAME__', name) : text;
  };
  const fill = (pairs) => {
    pairs.forEach(([selector, value]) => {
      const input = root.querySelector(selector);
      if (!input) return;
      input.value = value;
      input.disabled = false;
    });
  };

  if (emne === VISIT) {
    const lamps = readJson('[data-wow-lamps]');
    if (has(lamps, handle)) {
      setSubject('data-wow-subject-visit-piece', lamps[handle]);
      fill([['[data-wow-lamp-name]', lamps[handle]], ['[data-wow-lamp-handle]', handle], ['[data-wow-lamp-request]', VISIT]]);
    } else {
      setSubject('data-wow-subject-visit');
    }
    return;
  }

  const pieces = readJson('[data-wow-pieces]');
  if (!has(pieces, handle)) return;
  setSubject('data-wow-subject-template');
  fill([['[data-wow-piece-name]', pieces[handle]], ['[data-wow-piece-handle]', handle]]);
})();
